<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Выдача продукта</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group" style="position: relative; z-index: 2;">
          <label>Продукт</label>
          <v-multiselect
            :options="options"
            v-model="selectedProduct"
            label="name"
          ></v-multiselect>
        </div>
        <div v-if="isCoffee" class="form-group" style="position: relative; z-index: 1;">
          <label>Сахар</label>
          <div class="mx-2">
            <el-slider
              v-model="sugar"
              :max="6"
              show-tooltip
              show-stops
            ></el-slider>
          </div>
        </div>
        <div v-if="isCoffee" class="custom-control custom-checkbox">
          <input ref="cup_checkbox" type="checkbox" class="custom-control-input" v-model="cup"  id="cup-checkbox">
          <label class="custom-control-label" for="cup-checkbox">Выдача стакана</label>
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          :disabled="!selectedProduct"
          @click="save"
        >Выдать продукт</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['matrix', 'isCoffee', 'modemUid'],
    data () {
      return {
        selectedProduct: null,
        sugar: 0,
        cup: true,
      }
    },
    methods: {
      save () {
        let data = {
          product_id: this.selectedProduct.id,
        }
        if (this.isCoffee) {
          data = Object.assign(data, {
            sugar: this.sugar,
            cup: this.cup,
          })
        }
        return api.post(`modems/${this.modemUid}/commands/dsl`, data).then(() => this.hide())
      },
      hide () {
        this.$emit('hide')
      },
    },
    computed: {
      options () {
        return this.matrix ? this.matrix.products.map((el) => el.product) : []
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/dsl-modal.vue